//react
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAps';
import { useEffect } from 'react';
//import { OrderType } from 'types/order';

const SlvrbulletTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'Slvrbullet';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const scriptId1 = 'SlvrbulletTag-load1';
    const isExsistLoadScript1 = document.getElementById(scriptId1);
    if (!!isExsistLoadScript1) isExsistLoadScript1.remove();

    if (!isThanks) {
      //const orderCode = order ? (order as OrderType).order_code : '';
      //const price = order ? order?.billing_amount + order?.tax_amount : 0;
      const script = document.createElement('script');
      script.id = scriptId;
      script.setAttribute('async', '');
      script.innerHTML = `
        (function(w,d,o,u,r,a,m){w['slvrbullet']=r;w[r]=w[r]||function(){(w[r].q= w[r].q||[]).push(arguments)},w[r].l=1*new Date();a=d.createElement(o),m=d.getElementsByTagName(o)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m);})(window,document,'script','https://tr.slvrbullet.com/cv.min.js','sl');
        var sl_cv_params={'domain':'​wifi-tokyo-rentalshop.com','cc':'w0000192356'};sl('c',sl_cv_params);
      `;
      document.body.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default SlvrbulletTag;
